import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Hero from "@/sections/Hero";
import EditorialMarquee from "@/sections/EditorialMarquee";
import Realisations from "@/sections/Realisations";
import ApercuGratuit from "@/sections/ApercuGratuit";
import Manifeste from "@/sections/Manifeste";
import Benefits from "@/sections/Benefits";
import Processus from "@/sections/Processus";
import SeoSection from "@/sections/SeoSection";
import Entreprise from "@/sections/Entreprise";
import Temoignages from "@/sections/Temoignages";
import Tarifs from "@/sections/Tarifs";
import Faq from "@/sections/Faq";
import ContactCta from "@/sections/ContactCta";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta();
  return (
    <div className="relative bg-[var(--bg-primary)]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Realisations />
        <ApercuGratuit />
        <Manifeste />
        <Benefits />
        <Processus />
        <SeoSection />
        <Entreprise />
        <Temoignages />
        <Tarifs />
        <Faq />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}
